/**
 * ProductListPresenter
 * --
 */
import React from 'react';
import {
  Content,
  Title,
  Row,
  Col,
  ExpandableContainer,
  Table,
  Statistic,
  Pagination,
} from 'components';
import { Avatar, Button, DatePicker, Input, Radio, Select } from 'antd';
import { PictureOutlined, PlusOutlined } from '@ant-design/icons';
import { stringToMoneyFormat } from 'utils';
import CONSTANTS from 'constants';

const ProductListPresenter = ({
  currentPage,
  isCheckedAll,
  checkedList,
  onPagination,
  onChecked,
  onCheckedAll,
  onDelete
}) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 20,
    },
    button: {
      width: 80,
      height: 40,
      fontSize: 15,
      fontWeight: 600,
      margin: '0px 4px',
    },
    form: {
      input: {
        large: {
          width: 175,
          marginRight: 8,
        },
        medium: {
          width: 100,
          marginRight: 8,
        },
      },
      button: {
        marginRight: 8,
      },
      date: {
        width: 120,
      },
      text: {
        fontSize: 13,
        fontWeight: 400,
      },
    },
  };

  const formItem = [
    {
      label: '검색어',
      direction: 'column',
      form: [
        {
          input: (
            <>
              <Select
                size="large"
                value={'메뉴번호'}
                options={[
                  { label: '메뉴번호', value: '메뉴번호' },
                  { label: '메뉴명', value: '메뉴명' },
                  { label: '제조사', value: '제조사' },
                  { label: '카다로그명', value: '카다로그명' },
                  { label: '브랜드명', value: '브랜드명' },
                ]}
                style={{ ...styles.form.input.large }}
              />
              <Input
                size="large"
                placeholder="검색어를 입력해주세요"
                style={{ ...styles.form.input.large, width: 350 }}
              />
              <Button size="large" icon={<PlusOutlined />} />
            </>
          ),
        },
      ],
    },
    {
      label: '판매 상태',
      form: [
        {
          input: (
            <>
              <Radio.Group value={'전체'}>
                <Radio value={'전체'}>전체</Radio>
                <Radio value={'판매대기'}>판매대기</Radio>
                <Radio value={'판매중'}>판매중</Radio>
                <Radio value={'품절'}>품절</Radio>
                <Radio value={'승인대기'}>승인대기</Radio>
                <Radio value={'판매종료'}>판매종료</Radio>
                <Radio value={'판매금지'}>판매금지</Radio>
              </Radio.Group>
            </>
          ),
        },
      ],
    },
    {
      label: '메뉴 구분',
      form: [
        {
          input: (
            <>
              <Radio.Group value={'전체'}>
                <Radio value={'전체'}>전체</Radio>
                <Radio value={'기본메뉴'}>기본메뉴</Radio>
                <Radio value={'세트메뉴'}>세트메뉴</Radio>
              </Radio.Group>
            </>
          ),
        },
      ],
    },
    {
      label: '메뉴 분류',
      form: [
        {
          input: (
            <>
              <Select
                size="large"
                options={[
                  { label: '대분류1', value: '대분류1' },
                  { label: '대분류2', value: '대분류2' },
                  { label: '대분류3', value: '대분류3' },
                ]}
                style={{ ...styles.form.input.large }}
                placeholder={'대분류 선택'}
              />
              <Select
                size="large"
                options={[
                  { label: '중분류1', value: '중분류1' },
                  { label: '중분류2', value: '중분류2' },
                  { label: '중분류3', value: '중분류3' },
                ]}
                style={{ ...styles.form.input.large }}
                placeholder={'중분류 선택'}
              />
              <Select
                size="large"
                options={[
                  { label: '소분류1', value: '소분류1' },
                  { label: '소분류2', value: '소분류2' },
                  { label: '소분류3', value: '소분류3' },
                ]}
                style={{ ...styles.form.input.large }}
                placeholder={'소분류 선택'}
              />
              <Select
                size="large"
                options={[
                  { label: '상세분류1', value: '상세분류1' },
                  { label: '상세분류2', value: '상세분류2' },
                  { label: '상세분류3', value: '상세분류3' },
                ]}
                style={{ ...styles.form.input.large }}
                placeholder={'상세분류 선택'}
              />
            </>
          ),
        },
      ],
    },
    {
      label: '메뉴 등록일/수정일',
      form: [
        {
          input: (
            <Select
              size="large"
              value={'등록일'}
              options={[
                { label: '등록일', value: '등록일' },
                { label: '최종 수정일', value: '최종 수정일' },
              ]}
              style={{ ...styles.form.input.large }}
            />
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              오늘
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              1주일
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              1개월
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              3개월
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              전체
            </Button>
          ),
        },
        {
          input: (
            <>
              <DatePicker
                size="large"
                format={'YYYY-MM-DD'}
                placeholder=""
                style={{ ...styles.form.date }}
              />
              <p style={{ ...styles.form.text, padding: '0px 2px' }}>~</p>
              <DatePicker
                size="large"
                format={'YYYY-MM-DD'}
                placeholder=""
                style={{ ...styles.form.date }}
              />
            </>
          ),
        },
      ],
    },
    {
      label: '진열 상태',
      form: [
        {
          input: (
            <>
              <Radio.Group value={'전체'}>
                <Radio value={'전체'}>전체</Radio>
                <Radio value={'진열함'}>진열함</Radio>
                <Radio value={'진열안함'}>진열안함</Radio>
              </Radio.Group>
            </>
          ),
        },
      ],
    },
    {
      label: '판매 상태',
      form: [
        {
          input: (
            <>
              <Radio.Group value={'전체'}>
                <Radio value={'전체'}>전체</Radio>
                <Radio value={'판매함'}>판매함</Radio>
                <Radio value={'판매안함'}>판매안함</Radio>
              </Radio.Group>
            </>
          ),
        },
      ],
    },
    {
      label: '마켓 연동',
      form: [
        {
          input: (
            <>
              <Radio.Group value={'전체'}>
                <Radio value={'전체'}>전체</Radio>
                <Radio value={'네이버'}>네이버</Radio>
                <Radio value={'카페24'}>카페24</Radio>
              </Radio.Group>
            </>
          ),
        },
      ],
    },
  ];

  // NOTE: 테이블 가짜 데이터
  let newData = [];
  // for (let i = 0; i < 50; i++) {
  //   newData.push({
  //     key: i,
  //     no: i + 1,
  //     카테고리: '커피',
  //     메뉴코드: `0000000`,
  //     img: <Avatar size={50} shape="square" icon={<PictureOutlined />} />,
  //     name: '카페라테',
  //     price: 20000,
  //     sale: 500,
  //     m_sale: 1000,
  //     url: `URL`,
  //   });
  // }

  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
      <Row>
        <Col x={24}>
          <Title style={{ ...styles.title }}>메뉴 목록</Title>

          {/* 요약 */}
          <Content
            maxWidth={'100%'}
            padding={0}
            backgroundColor={'none'}
            style={{ marginBottom: 40, display: 'flex' }}
          >
            {[
              { title: '전체', value: 0 },
              { title: '판매대기', value: 0 },
              { title: '판매중', value: 0 },
              { title: '품절', value: 0 },
              { title: '승인대기', value: 0 },
              { title: '판매중지', value: 0 },
              { title: '판매종료', value: 0 },
              { title: '판매금지', value: 0 },
            ].map((_item, _index) => (
              <div
                key={`${_item.label}-${_index}`}
                style={{
                  background: '#FFFFFF',
                  borderRadius: 4,
                  width: `calc(100% / 8)`,
                  marginRight: _index === 7 ? 0 : 4,
                  padding: 20,
                }}
              >
                <Statistic
                  title={_item.title}
                  value={_item.value}
                  suffix={'건'}
                  direction={'row'}
                  style={{ justifyContent: 'center' }}
                />
              </div>
            ))}
          </Content>
          {/* 요약 끝 */}

          {/* 검색필터 */}
          <Content
            maxWidth={'100%'}
            padding={0}
            backgroundColor={'none'}
            style={{ marginBottom: 40 }}
          >
            <ExpandableContainer borderRadius={4} padding={20}>
              {formItem.map((_item, _index) => (
                <div
                  key={`form_${_index}`}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '10px 0px',
                  }}
                >
                  <div style={{ width: 120, fontSize: 13, fontWeight: 400 }}>
                    <label>{_item.label}</label>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    {_item.form.map((_subitem, _subkey) => (
                      <React.Fragment key={`input_${_subkey}`}>
                        {_subitem.input}
                      </React.Fragment>
                    ))}
                  </div>
                </div>
              ))}
            </ExpandableContainer>

            {/* 검색/초기화 버튼 */}
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                marginTop: 48,
              }}
            >
              <Button
                size="large"
                type="primary"
                style={{ ...styles.button, background: 'var(--primary-color)' }}
              >
                검색
              </Button>
              <Button size="large" style={{ ...styles.button }}>
                초기화
              </Button>
            </div>
            {/* 검색/초기화 버튼 끝 */}
          </Content>
          {/* 검색필터 끝 */}

          {/* 검색결과 */}
          <Content maxWidth={'100%'} borderRadius={4} padding={20}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: 20,
                justifyContent: 'space-between',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <h4 style={{ fontSize: 14, fontWeight: 500, marginRight: 20 }}>
                  총 <span>0</span>건
                </h4>

                <ul style={{ display: 'flex', gap: 8 }}>
                  <li>
                    <Button>선택삭제</Button>
                  </li>
                  <li>
                    <Select
                      value={CONSTANTS.DISPLAY_OPTION[0].value}
                      options={CONSTANTS.DISPLAY_OPTION}
                    />
                  </li>
                  <li>
                    <Select
                      value={CONSTANTS.SALE_OPTION[0].value}
                      options={CONSTANTS.SALE_OPTION}
                    />
                  </li>
                  <li>
                    <Select
                      value={''}
                      options={[
                        {
                          label: '일괄변경',
                          value: '',
                        },
                        {
                          label: '이벤트 문구',
                          value: '이벤트 문구',
                        },
                        {
                          label: '구매혜택',
                          value: '구매혜택',
                        },
                        {
                          label: '수량제한',
                          value: '수량제한',
                        },
                        {
                          label: '메뉴정보',
                          value: '메뉴정보',
                        },
                        {
                          label: '원산지',
                          value: '원산지',
                        },
                        {
                          label: '특이사항',
                          value: '특이사항',
                        },
                      ]}
                    />
                  </li>

                  <li>
                    <Button>엑셀 다운로드</Button>
                  </li>
                </ul>
              </div>
              <div>
                <Select
                  size="large"
                  value={'등록일순'}
                  options={[
                    { label: '등록일순', value: '등록일순' },
                    { label: '높은 가격순', value: '높은 가격순' },
                    { label: '낮은 가격순', value: '낮은 가격순' },
                    { label: '할인순', value: '할인순' },
                  ]}
                  style={{ ...styles.form.input.large }}
                />
              </div>
            </div>

            <Table
              data={newData.slice(
                (currentPage - 1) * 10,
                (currentPage - 1) * 10 + 10
              )}
              isChecked
              columns={[
                {
                  title: 'No',
                  key: 'no',
                },
                {
                  title: '카테고리',
                  key: '카테고리',
                },
                {
                  title: '메뉴코드',
                  key: '메뉴코드',
                },
                {
                  title: '메뉴 이미지',
                  key: 'img',
                },
                {
                  title: '메뉴명',
                  key: 'name',
                },
                {
                  title: '판매가',
                  key: 'price',
                  render: (item) => stringToMoneyFormat(item),
                },
                {
                  title: '할인가',
                  key: 'sale',
                  render: (item) => stringToMoneyFormat(item),
                },
                {
                  title: '모바일 할인가',
                  key: 'm_sale',
                  render: (item) => stringToMoneyFormat(item),
                },
                {
                  title: 'URL',
                  key: 'url',
                },
              ]}
              checkedAll={isCheckedAll}
              checkedList={checkedList}
              onChecked={onChecked}
              onCheckedAll={onCheckedAll}
            />

            <Pagination
              current={currentPage}
              pageSize={10}
              total={newData.length}
              onChange={(e) => onPagination(e)}
              style={{ marginTop: 40 }}
            />
          </Content>
          {/* 검색결과 끝 */}
        </Col>
      </Row>
    </Content>
  );
};

export default ProductListPresenter;
